import React from "react";

const Terms = () => {
  return (
    <div className="max-w-6xl mx-auto p-8 bg-white shadow-lg rounded-lg text-gray-800 mt-8">
      <h1 className="text-4xl font-bold mb-6 text-center text-green-600">Terms and Conditions</h1>
      <p className="mb-6 text-lg text-gray-600 text-center">Welcome to <strong>Investycoons</strong>. These terms and conditions outline the rules and regulations for using our real estate brokerage services.</p>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">1. Introduction</h2>
        <p>By accessing this website, you accept these terms and conditions in full. Do not continue to use Investycoons’ website if you do not accept all of the terms stated here.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">2. Services</h2>
        <p>Investycoons provides real estate brokerage services, including property listings, consultations, and transactions. We ensure a smooth and transparent process for clients.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">3. User Responsibilities</h2>
        <p>Users must provide accurate information and comply with all legal obligations when using our services. Fraudulent activities may lead to termination of services.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">4. Privacy Policy</h2>
        <p>We value your privacy. Your use of our services is governed by our Privacy Policy, outlining data collection and protection practices.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">5. Limitation of Liability</h2>
        <p>Investycoons does not guarantee the accuracy of property listings. Users should conduct due diligence before making any real estate decisions.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">6. Governing Law</h2>
        <p>These terms are governed by the laws of [Jurisdiction]. Any disputes will be resolved under the jurisdiction of [Jurisdiction] courts.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">7. Fees and Payments</h2>
        <p>Investycoons may charge service fees for transactions. Payments must be made through approved channels, and delays may lead to service suspension.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">8. Intellectual Property</h2>
        <p>All content, trademarks, and materials on this website are the property of Investycoons. Unauthorized use is prohibited.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">9. Changes to Terms</h2>
        <p>We reserve the right to modify these terms at any time. Continued use of our services signifies acceptance of changes.</p>
      </div>

      <div className="border-t border-gray-300 pt-6">
        <h2 className="text-2xl font-semibold mt-4 mb-2">10. Contact Information</h2>
        <p>If you have any questions, please contact us at <strong>connect@investycoons.com</strong>. Our team is happy to assist you.</p>
      </div>
    </div>
  );
};

export default Terms